<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="group.items"
      item-key="id"
      hide-default-footer
      class="shadow c-data-table--alternate overflow-hidden"
    >
      <template #top>
        <div class="pl-4 py-2">
          <v-row row wrap justify="space-between" align="center">
            <v-col lg="6">
              <div class="body-1 navy--text text--darken-1 font-weight-medium">
                {{ groupTitleByIndex }}
              </div>
            </v-col>
            <v-col>
              <div class="d-flex justify-end text-xs-right mr-4">
                <v-btn
                  color="navy"
                  text
                  small
                  @click="modalInterestsOpened = true"
                >
                  <v-icon left>
                    mdi-plus-circle-outline
                  </v-icon>
                  Přidat okruh zájmu
                </v-btn>
                <v-btn
                  color="navy"
                  text
                  small
                  :disabled="suggestionsDisabled"
                  @click="modalSuggestionsOpened = true"
                >
                  <v-icon left>
                    mdi-help-circle-outline
                  </v-icon>
                  Návrhy okruhů zájmu
                </v-btn>

                <v-btn
                  text
                  small
                  color="red"
                  @click="groupRemove"
                  :disabled="disableDelete"
                >
                  <v-icon>
                    mdi-delete-outline
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </template>

      <template #item.name="{ item }">
        <div class="py-6" v-text="item.name" />
      </template>

      <template #item.audience_size="{ item }">
        {{
          item.audienceSizeLowerBound
            ? item.audienceSizeLowerBound.toLocaleString()
            : ""
        }}
      </template>

      <template #item.path="{ item }">
        {{ item.path ? item.path.join(" > ") : "" }}
      </template>

      <template #item.actions="{ item }">
        <v-btn @click="itemsRemove(item)" text small color="primary">
          <v-icon left>
            mdi-minus-circle-outline
          </v-icon>
          Smazat
        </v-btn>
      </template>

      <template #no-data>
        <div class="pt-14">
          <ui-audience-group-diagram
            :n="groupIndex + 1"
            class="navy--text text--lighten-2 mb-12"
            :style="{
              '--diagram-label-color': 'var(--v-navy-lighten1)',
            }"
          />
          <div class="pb-9 primary--text">
            <div class="text-h5 mb-2 font-weight-medium">
              Přidejte okruh zájmu
            </div>
            <div class="mb-8 mx-auto" :style="{ maxWidth: '410px' }">
              Pro dobré zacílení, přidejte okruh zájmu. Pro precizní zacílení,
              vytvořte skupinu a té přiřaďte další okruhy zájmu.
            </div>
            <div>
              <v-btn
                class="c-btn"
                color="primary"
                @click="modalInterestsOpened = true"
              >
                Přidat okruh zájmu
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </template>
    </v-data-table>

    <targeting-interests-modal
      :opened.sync="modalInterestsOpened"
      @save="itemsAppend"
    />

    <targeting-suggestions-modal
      v-if="group.items"
      :opened.sync="modalSuggestionsOpened"
      :source-data="group.items"
      @save="itemsAppend"
    />
  </div>
</template>

<script>
import TargetingInterestsModal from "@/components/ui/modals/TargetingInterestsModal.vue"
import TargetingSuggestionsModal from "@/components/ui/modals/TargetingSuggestionsModal.vue"

const headers = [
  // { text: "", value: "drag", sortable: false },
  {
    text: "Zájem",
    align: "start",
    value: "name",
    sortable: false,
  },
  { text: "Velikost publika", value: "audience_size", sortable: false },
  { text: "Cesta", value: "path", sortable: false },
  { text: "", value: "actions", sortable: false },
]

export default {
  name: "InterestsGroup",
  components: {
    TargetingInterestsModal,
    TargetingSuggestionsModal,
  },
  props: {
    disableDelete: {
      type: Boolean,
      default: false,
    },
    group: {
      type: Object,
      required: true,
    },
    groupIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      headers,
      modalInterestsOpened: false,
      modalSuggestionsOpened: false,
    }
  },
  computed: {
    groupTitleByIndex() {
      switch (this.groupIndex) {
        case 0:
          return "Základní skupina"
        case 1:
          return "Druhá skupina"
        case 2:
          return "Třetí skupina"
        default:
          return "Další skupina"
      }
    },
    suggestionsDisabled() {
      if (!this.group.items) {
        return false
      }

      return this.group.items.length < 1
    },
  },
  methods: {
    groupRemove() {
      this.$emit("groupRemove", this.group)
    },
    itemsAppend(items) {
      this.$emit("itemsAppend", {
        group: this.group,
        items,
      })
    },
    itemsRemove(items) {
      this.$emit("itemsRemove", {
        group: this.group,
        items,
      })
    },
    onSuggestionsDialogOpenClick() {
      this.modalSuggestionsOpened = true
    },
  },
}
</script>
